import React from 'react'
import { Link } from 'react-router-dom'
import { ArticlesListType } from '../../../models/news-articles/articles-filtered-model'

type articleType = {
  article: ArticlesListType
}

const Newsarticle = (props: articleType) => {

  const { article } = props

  return (
    <div className=" single-grid summary-latest second-article-section">
      <div className="featured-image col-md-4 p-0 c1_r1_c1">
        <Link className="link-see-more" to={article.articleUrl}>
          <img src={article.articleTeaserImage} alt={article.articleName} className="img-pin-article" loading="lazy" />
        </Link>
      </div>
      <div className="post-content c1_r1_c2 summary-latest">
        <div className="post-meta  p-0 m-0">
          <div className="data-right">
            <span className="article-date">{article.articleReleaseDate}</span>| <span className='authors'> By <span dangerouslySetInnerHTML={{ __html: article.author }}></span></span>
          </div>
          <div className="col-md-4 p-0 col-xs-12">
            <span className="category" dangerouslySetInnerHTML={{ __html: article.badgeUrl }}></span>
            <span className="totalArticles hide">4</span>
          </div>
        </div>
        <div className="head">
          <Link to={article.articleUrl}><h5>{article.articleName}</h5></Link>
        </div>
        <p>{article.articleTeaserText}</p>
        <Link className="link-see-more" to={article.articleUrl}>See More</Link>
      </div>
    </div>
  )
}

export default Newsarticle



